import { DetermineBrightness } from "./DetermineBrightness";
import { XML_DrawText } from "./XML_DrawText";
import { kTriAnnoW, gBrightnessThreshold, enumXMLType } from "../constants";

export function XML_DrawAnnoLabel(
  annoLabel,
  bounds,
  triSize,
  triColor,
  triPosition,
  drawElement,
  layer
) {
  var tSize = kTriAnnoW; // EPS_Scale(triSize,drawElement);

  var t3 = 0.3333 * tSize;
  var t2 = 0.3333 * tSize;

  var sx = triPosition == 0 ? bounds.fRight - t2 : bounds.fLeft + t2;
  var sy = bounds.fTop + t3;
  bounds.fBottom = bounds.fTop + tSize;

  var fillStyle = "#000000";
  if (triColor != null)
    fillStyle = DetermineBrightness(triColor) < gBrightnessThreshold ? "#FFFFFF" : "#000000";

  var docType = drawElement.GetDocType();

  if (docType != enumXMLType.PDF) {
    sx = sx - tSize / 2;
    sy = sy - 11 / 2 - 3;
    sx = triPosition == 0 ? sx + 1 : sx - 1;
    bounds.fLeft = sx;
    bounds.fRight = bounds.fLeft + tSize;
    bounds.fTop = sy;
  }
  XML_DrawText(
    annoLabel,
    sx,
    sy,
    fillStyle,
    "Tahoma",
    11,
    true,
    false,
    false,
    "center",
    "middle",
    bounds,
    drawElement,
    layer
  );
}
